import './LeftNav.css';
import { useSelector, useDispatch } from "react-redux";
import { setSupplementary } from "../Store/LoadReducer";
import { formatInputNumber } from "../../helpers/utils";

function PINNGeneral() {
    const supplementary = useSelector(item => item.flowviewer.supplementary);
    const dispatch = useDispatch();


    const toggleBlock = (event) => {
        const targetBlock = event.target.parentElement;
        targetBlock.classList.toggle('active', !targetBlock.classList.contains('active'));
    }

    function validateSupplementary(name, value) {
        const floatValidator = (v) => {
            v = v.replace('.', ',');
            return {
                result: (v == "" || /^-?\d+,?\d*$/.test(v)),
                value: v
            }
        };
        const integerValidator = (v) => {
            return {
                result: (v == "" || /^-?\d+$/.test(v)),
                value: v
            }
        }
        const booleanValidator = (v) => {
            return {
                result: (v == "" || v === "1" || v === "0"),
                value: v
            };
        }

        const validator = {
            age: integerValidator,
            gender: booleanValidator,
            height: floatValidator,
            weight: floatValidator,
        };
        if (validator.hasOwnProperty(name)) {
            return validator[name](value);
        } else {
            return {
                result: true,
                value: value
            }
        }
    }

    const onChangeSupplementary = (e, name) => {
        const validationResult = validateSupplementary(name, e.target.value);
        if (validationResult.result) {
            dispatch(setSupplementary({
                name: name,
                value: validationResult.value,
                modelType: "pinn"
            }));
        }
    };

    return (
        <div className="mt-2 mb-2">
            <div className="d-flex align-items-center text-white mb-2">
                <p className="mb-0 title-meas">Age</p>
                <input onChange={(e) => onChangeSupplementary(e, "age")}
                    className="input-measurements me-2"
                    type="text"
                    value={supplementary["pinn"].hasOwnProperty("age") ? formatInputNumber(supplementary["pinn"].age) : ""} />
                <p className="mb-0">years</p>
            </div>
            <div className="d-flex align-items-center text-white mb-2">
                <p className="mb-0 title-meas">Gender</p>
                <div className="d-flex flex-column">
                    <div className="d-flex align-items-center mb-2">
                        <input id="gender_male" onChange={(e) => onChangeSupplementary(e, "gender")}
                            className="input-measurements me-2"
                            name="gender"
                            checked={supplementary["pinn"].gender == 1 ? "checked" : ""}
                            type="radio"
                            value="1" />
                        <label htmlFor="gender_male">Male</label>
                    </div>
                    <div className="d-flex align-items-center">
                        <input id="gender_female" onChange={(e) => onChangeSupplementary(e, "gender")}
                            className="input-measurements me-2"
                            name="gender"
                            checked={supplementary["pinn"].gender == 0 ? "checked" : ""}
                            type="radio"
                            value="0" />
                        <label htmlFor="gender_female">Female</label>
                    </div>
                </div>
            </div>
            <div className="d-flex align-items-center text-white mb-2">
                <p className="mb-0 title-meas">Height</p>
                <input onChange={(e) => onChangeSupplementary(e, "height")}
                    className="input-measurements me-2"
                    type="text"
                    value={supplementary["pinn"].hasOwnProperty("height") ? formatInputNumber(supplementary["pinn"].height) : ""} />
                <p className="mb-0">cm</p>
            </div>
            <div className="d-flex align-items-center text-white mb-2">
                <p className="mb-0 title-meas">Weight</p>
                <input onChange={(e) => onChangeSupplementary(e, "weight")}
                    className="input-measurements me-2"
                    type="text"
                    value={supplementary["pinn"].hasOwnProperty("weight") ? formatInputNumber(supplementary["pinn"].weight) : ""} />
                <p className="mb-0">kg</p>
            </div>
        </div>
    );
}

export default PINNGeneral;